"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactQuery = require("@tanstack/react-query");
var _useUserService = _interopRequireDefault(require("./useUserService"));
const GET_USER_KEY = "get-user-data";
const VEHICLE_LIMIT_BY_ACCOUNT_TYPE = {
  PERSON: 5,
  BUSINESS: 10
};
const GetUserApiAdapter = function (data) {
  const [firstCustomer] = data.completeUser.customer;
  const payload = {
    ...data.completeUser.account,
    ...firstCustomer
  };
  return {
    ...payload,
    ...(payload.alternatePhone && {
      alternatePhoneNumber: `${payload.alternatePhone.areaCode}${payload.alternatePhone.phoneNo}`
    }),
    ...(payload.postalAddresses.length > 0 && function () {
      const [firstAddress] = payload.postalAddresses;
      return {
        address1: firstAddress.addressLine1,
        address2: firstAddress.addressLine2,
        city: firstAddress.city,
        state: firstAddress.state,
        zip: firstAddress.postalCode.substring(0, 5)
      };
    }()),
    phoneNumber: payload.telephoneNumber,
    maxVehicles: VEHICLE_LIMIT_BY_ACCOUNT_TYPE[payload.customerType]
  };
};

// By default we'll always make this call, but you can pass in a check that if false will skip the api call
const useUserQuery = function () {
  let forceRefresh = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  let options = arguments.length > 1 ? arguments[1] : undefined;
  const service = (0, _useUserService.default)();
  return (0, _reactQuery.useQuery)({
    queryKey: [GET_USER_KEY, forceRefresh],
    queryFn: async function () {
      const {
        data
      } = await service.get.user();
      return GetUserApiAdapter(data);
    },
    enabled: forceRefresh,
    ...options
  });
};
var _default = exports.default = useUserQuery;